import React from "react";
import classes from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={classes.footercss}>
      <div className="container">
        <span>Made with Love , Team Travel Buddy ♥</span>
      </div>
    </footer>
  );
};

export default Footer;
